/**
 * Decode HTML entities in a string so that values like &#39; or &apos; display as '.
 * Handles numeric entities (&#39;, &#x27;) and common named entities (&apos;, &quot;, &amp;, &lt;, &gt;).
 *
 * @param text String that may contain HTML entities
 * @returns Decoded string
 */
export const decodeHtmlEntities = (text: string): string => {
    if (typeof text !== "string" || text.length === 0) {
        return text;
    }
    return text
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(parseInt(code, 10)))
        .replace(/&#x([0-9a-fA-F]+);/g, (_, code) => String.fromCharCode(parseInt(code, 16)))
        .replace(/&apos;/g, "'")
        .replace(/&quot;/g, '"')
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&");
};
